import { isObject } from 'underscore';
import { getLinkType, LinkProviders } from './formats-and-sources';

const oembedLinks: Record<string, () => URL> = {
  [LinkProviders.youtube]: () => new URL(`https://youtube.com/oembed`),
  [LinkProviders.vimeo]: () => new URL(`https://vimeo.com/api/oembed.json`),
  [LinkProviders.twitch]: () => new URL(`https://api.twitch.tv/v5/oembed`),
  [LinkProviders.wistia]: () => new URL('https://fast.wistia.com/oembed'),
};

export const getLinkThumbnail = async (link: string) => {
  try {
    const provider = getLinkType(link);
    const oembedUrl = oembedLinks[provider as string]?.();

    if (oembedUrl) {
      oembedUrl.searchParams.set('url', link);
      oembedUrl.searchParams.set('format', 'json');
      const res = await fetch(oembedUrl).then((res) => {
        if (res.ok && res.headers.get('Content-Type')?.includes('application/json')) {
          return res.json();
        }

        throw new Error(`Cannot get thumbnail ${link}: ${res.statusText}`);
      });
      if (isObject(res) && 'thumbnail_url' in res) {
        return res.thumbnail_url;
      }
    }

    return undefined;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
